import api from "../_app/api";
import { UserType } from "./types";

export const getMyUserLevelType = async () => {
  const { data }: { data: UserType } = await api({
    method: "GET",
    url: "/user-levels/my",
  });

  return data;
};
